import{
    appOpenHomePageApi
}from   '@/api/app'
export function    recordIndexRequest(){
    let requestData = {
        userAgent:navigator.userAgent.toLowerCase()
    }
    appOpenHomePageApi(requestData).then(res=>{

    },err=>{
        
    })
}